import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaMusic, FaAward, FaUsers } from 'react-icons/fa';
import '../../../assets/css/sliderCircular.css';

const SliderCircular = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
const slides = [
  {
    mainImage: '/img/slide-circular/foto_waldir_pianos1.jpg',
    circleImages: [
      '/img/slide-circular/foto_waldir_pianos2.jpg',
      '/img/slide-circular/foto_waldir_pianos3.jpg',
      '/img/slide-circular/foto_waldir_pianos4.jpg',
      '/img/slide-circular/foto_waldir_pianos5.jpg',
  
    ],
    title: "Mão de Obra Própria",
    description: "Garantia de experiência dedicação e preço justo."
  },
  {
    mainImage: '/img/slide-circular/foto_waldir_pianos2.jpg',
    circleImages: [
      '/img/slide-circular/foto_waldir_pianos1.jpg',
      '/img/slide-circular/foto_waldir_pianos3.jpg',
      '/img/slide-circular/foto_waldir_pianos4.jpg',
      '/img/slide-circular/foto_waldir_pianos5.jpg',
   
    ],
    title: "Referência no assunto",
    description: "Inúmeros clientes e amigos ao longo dessa trajetória."
  },
  {
    mainImage: '/img/slide-circular/foto_waldir_pianos3.jpg',
    circleImages: [
      '/img/slide-circular/foto_waldir_pianos1.jpg',
      '/img/slide-circular/foto_waldir_pianos2.jpg',
      '/img/slide-circular/foto_waldir_pianos4.jpg',
      '/img/slide-circular/foto_waldir_pianos5.jpg',
      
    ],
    title: "Legado Familiar",
    description: "Da nossa família para a sua. Experiência de meio século passada de pai para filhos."
  },
  {
    mainImage: '/img/slide-circular/foto_waldir_pianos4.jpg',
    circleImages: [
      '/img/slide-circular/foto_waldir_pianos1.jpg',
      '/img/slide-circular/foto_waldir_pianos2.jpg',
      '/img/slide-circular/foto_waldir_pianos3.jpg',
      '/img/slide-circular/foto_waldir_pianos5.jpg',
     
    ],
    title: "Conhecimento Técnico",
    description: "Equipe composta pelos melhores técnicos das antigas fábricas de São Paulo."
  },
  {
    mainImage: '/img/slide-circular/foto_waldir_pianos5.jpg',
    circleImages: [
      '/img/slide-circular/foto_waldir_pianos1.jpg',
      '/img/slide-circular/foto_waldir_pianos2.jpg',
      '/img/slide-circular/foto_waldir_pianos3.jpg',
      '/img/slide-circular/foto_waldir_pianos4.jpg',

    ],
    title: "Reforma, Venda e Descupinização",
    description: "Combinação da tradição com a modernidade da juventude. Com nossa familia seu piano estará em boas mãos."
  },

];


  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 6000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const calculatePosition = (index, total) => {
    const angle = (index * (-100 / total)) * (Math.PI / -180);
    const radius = -200; // Distância do centro (fora do círculo maior)
    return {
      x: Math.cos(angle) * radius,
      y: Math.sin(angle) * radius
    };
  };

  const handleCircleClick = (imgIndex) => {
    const newIndex = slides.findIndex(slide => slide.mainImage === slides[currentIndex].circleImages[imgIndex]);
    if (newIndex !== -1) {
      setCurrentIndex(newIndex);
    }
  };

  return (
    <div className="circular-slider-container">
      <div className="slider-circular-wrapper">
        <div className="circular-slider">
          <div className="main-circle-container">
            <AnimatePresence mode='wait'>
              <motion.div
                key={currentIndex}
                className="main-circle"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                <img 
                  src={slides[currentIndex].mainImage} 
                  alt="Piano principal" 
                  className="main-image"
                  loading="lazy"
                />
              </motion.div>
            </AnimatePresence>

            {slides[currentIndex].circleImages.map((img, index) => {
              const pos = calculatePosition(index, slides[currentIndex].circleImages.length);
              return (
                <motion.div
                  key={`${currentIndex}-${index}`}
                  className="small-circle"
                  style={{
                    left: `calc(50% + ${pos.x}px)`,
                    top: `calc(50% + ${pos.y}px)`
                  }}
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ 
                    delay: index * 0.1,
                    type: 'spring'
                  }}
                  whileHover={{ scale: 1.1 }}
                  onClick={() => handleCircleClick(index)}
                >
                  <img 
                    src={img} 
                    alt={`Detalhe ${index + 1}`} 
                    className="small-image"
                    loading="lazy"
                  />
                </motion.div>
              );
            })}
          </div>
        </div>

        <div className="slider-controls">
          <button 
            className="control-button prev"
            onClick={prevSlide}
            aria-label="Slide anterior"
          >
            &larr;
          </button>
          <div className="pagination">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`pagination-dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Ir para slide ${index + 1}`}
              />
            ))}
          </div>
          <button 
            className="control-button next"
            onClick={nextSlide}
            aria-label="Próximo slide"
          >
            &rarr;
          </button>
        </div>
      </div>

      <div className="texto-content">
        <motion.div
          key={`text-${currentIndex}`}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          <h2>

            {slides[currentIndex].title}

          </h2>
          <p>{slides[currentIndex].description}</p>
          <div className="values">
            <div className="value-item">
              <FaUsers className="value-icon" />
              <span>3 Gerações</span>
            </div>
            <div className="value-item">
              <FaAward className="value-icon" />
              <span>55+ Anos</span>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default SliderCircular;